import { FileContext } from '../../../../contexts/FileContext';
import { File } from '../../../../interfaces/File';
import { SnackbarParameters } from '../../../../interfaces/Snackbar';
import withSnackbar from '../../../../shared/components/withSnackbar';
import './FileUpload.scss';
import { SovosFileUpload } from 'mosaic-react';
import { useContext, useEffect } from 'react';

export const BATCH_ASSETS_URL = '/api/v1/batch/assets';

interface FileUploadProps {
	showSnackbar: (value: SnackbarParameters) => void;
}

const TEMPLATE_COMPATIBILITY_ERROR_MESSAGE =
	'File content does not match template. Please update template or file and try again.';
let fileUploadInput: any = null;
let dropFileZone: any = null;

const FileUpload: React.FC<FileUploadProps> = (props: FileUploadProps) => {
	const { showSnackbar } = props;
	const { uploadFile, deleteFile, selectedFiles, isFileUploading } = useContext(FileContext);

	const enableDropFileZoneAndFileUploadInput = (): void => {
		fileUploadInput?.removeAttribute('disabled');
		dropFileZone.style.cursor = 'pointer';
	};

	const handleDeleteFile = (): void => {
		enableDropFileZoneAndFileUploadInput();
		if (selectedFiles) {
			const fileId = selectedFiles[0].id.toString();
			deleteFile(fileId);
		}
	};

	const handleSelectFile = (filesSelected: File[]): void => {
		if (filesSelected && filesSelected.length > 0 && selectedFiles.length < 1) {
			fileUploadInput.setAttribute('disabled', 'true');
			dropFileZone.style.cursor = 'default';

			filesSelected.forEach(file => {
				uploadFile(file);
			});
		} else if (filesSelected && filesSelected.length > 0) {
			showSnackbar({ message: 'Unable to upload file.', variant: 'error' });
		}
	};

	useEffect(() => {
		if (!selectedFiles) {
			showSnackbar({
				message: TEMPLATE_COMPATIBILITY_ERROR_MESSAGE,
				variant: 'error',
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedFiles]);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => deleteFile(), []);

	useEffect(() => {
		fileUploadInput = document.querySelector('.file-upload__container input');
		dropFileZone = document.querySelector('.file-upload__container div');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedFiles, props, isFileUploading]);

	return (
		<div className='file-upload__container'>
			<SovosFileUpload
				acceptedTypes={['csv', 'zip']}
				multiple={false}
				headingLabel='Upload file'
				helpLabel='Drag and drop or browse'
				maxSize={52428800}
				fileList={[...selectedFiles]}
				onFileDelete={handleDeleteFile}
				onFilesSelected={handleSelectFile}
			/>
		</div>
	);
};

export default withSnackbar(FileUpload);
